// extracted by mini-css-extract-plugin
module.exports = {"header":"g_","headerBg":"ha"};